import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/10 via-lightBlue to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-heading font-bold text-4xl lg:text-5xl text-darkBlue mb-6">
              Çerez Politikası
            </h1>
            <p className="font-body text-lg text-gray-600 leading-relaxed">
              Web sitemizde kullanılan çerezler hakkında bilgilendirme
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="bg-lightBlue/30 rounded-xl p-8 mb-8">
              <p className="font-body text-gray-700 leading-relaxed">
                <strong className="text-darkBlue">İzmir Vize Danışmanlık</strong> olarak, web sitemizde kullanıcı deneyimini iyileştirmek ve hizmetlerimizi geliştirmek amacıyla çerezler kullanmaktayız. Bu politika, çerezlerin nasıl kullanıldığını ve yönetildiğini açıklamaktadır.
              </p>
            </div>

            <div className="space-y-8">
              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  1. Çerez Nedir?
                </h2>
                <p className="font-body text-gray-700 leading-relaxed">
                  Çerezler, bir web sitesini ziyaret ettiğinizde cihazınıza (bilgisayar, tablet veya mobil cihaz) kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin düzgün çalışmasını sağlamak, kullanıcı deneyimini iyileştirmek ve site trafiğini analiz etmek için kullanılır.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  2. Çerez Türleri
                </h2>
                
                <div className="space-y-6">
                  <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-secondary">
                    <h3 className="font-heading font-bold text-xl text-darkBlue mb-3">
                      Zorunlu Çerezler
                    </h3>
                    <p className="font-body text-gray-700 leading-relaxed mb-3">
                      Web sitesinin temel işlevlerini yerine getirmesi için gerekli olan çerezlerdir. Bu çerezler olmadan web sitesi düzgün çalışmaz.
                    </p>
                    <ul className="space-y-2 font-body text-gray-700">
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                        <span>Oturum yönetimi çerezleri</span>
                      </li>
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                        <span>Güvenlik çerezleri</span>
                      </li>
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                        <span>Dil tercihi çerezleri</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-primary">
                    <h3 className="font-heading font-bold text-xl text-darkBlue mb-3">
                      Analitik Çerezler
                    </h3>
                    <p className="font-body text-gray-700 leading-relaxed mb-3">
                      Web sitesinin nasıl kullanıldığını anlamamıza yardımcı olan çerezlerdir. Bu bilgiler, site performansını iyileştirmek için kullanılır.
                    </p>
                    <ul className="space-y-2 font-body text-gray-700">
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-primary mt-1 flex-shrink-0"></i>
                        <span>Google Analytics çerezleri</span>
                      </li>
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-primary mt-1 flex-shrink-0"></i>
                        <span>Sayfa görüntüleme istatistikleri</span>
                      </li>
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-primary mt-1 flex-shrink-0"></i>
                        <span>Kullanıcı davranış analizi</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-orange-500">
                    <h3 className="font-heading font-bold text-xl text-darkBlue mb-3">
                      Pazarlama Çerezleri
                    </h3>
                    <p className="font-body text-gray-700 leading-relaxed mb-3">
                      Size özel reklamlar göstermek ve pazarlama kampanyalarının etkinliğini ölçmek için kullanılan çerezlerdir.
                    </p>
                    <ul className="space-y-2 font-body text-gray-700">
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-orange-500 mt-1 flex-shrink-0"></i>
                        <span>Reklam hedefleme çerezleri</span>
                      </li>
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-orange-500 mt-1 flex-shrink-0"></i>
                        <span>Sosyal medya çerezleri</span>
                      </li>
                      <li className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-orange-500 mt-1 flex-shrink-0"></i>
                        <span>Yeniden pazarlama çerezleri</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  3. Çerezlerin Kullanım Amaçları
                </h2>
                <p className="font-body text-gray-700 leading-relaxed mb-4">
                  Web sitemizde çerezleri aşağıdaki amaçlarla kullanmaktayız:
                </p>
                <ul className="space-y-2 font-body text-gray-700">
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Web sitesinin düzgün çalışmasını sağlamak</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kullanıcı tercihlerini hatırlamak</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Site performansını analiz etmek ve iyileştirmek</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Kullanıcı deneyimini kişiselleştirmek</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>Güvenlik önlemlerini uygulamak</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-fill text-secondary mt-1 flex-shrink-0"></i>
                    <span>İlgili içerik ve reklamlar sunmak</span>
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  4. Çerezleri Nasıl Yönetebilirsiniz?
                </h2>
                <p className="font-body text-gray-700 leading-relaxed mb-4">
                  Çerezleri tarayıcı ayarlarınızdan yönetebilir, silebilir veya engelleyebilirsiniz. Ancak, zorunlu çerezleri engellerseniz web sitesinin bazı özellikleri düzgün çalışmayabilir.
                </p>
                
                <div className="bg-gray-50 rounded-lg p-6">
                  <h4 className="font-heading font-bold text-lg text-darkBlue mb-3">
                    Popüler Tarayıcılarda Çerez Ayarları:
                  </h4>
                  <ul className="space-y-2 font-body text-gray-700">
                    <li className="flex items-start space-x-2">
                      <i className="ri-chrome-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>Google Chrome:</strong> Ayarlar → Gizlilik ve güvenlik → Çerezler ve diğer site verileri</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-firefox-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>Mozilla Firefox:</strong> Ayarlar → Gizlilik ve Güvenlik → Çerezler ve Site Verileri</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-safari-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>Safari:</strong> Tercihler → Gizlilik → Çerezler ve web sitesi verileri</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-edge-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>Microsoft Edge:</strong> Ayarlar → Gizlilik, arama ve hizmetler → Çerezler ve site izinleri</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  5. Üçüncü Taraf Çerezleri
                </h2>
                <p className="font-body text-gray-700 leading-relaxed mb-4">
                  Web sitemizde aşağıdaki üçüncü taraf hizmetlerin çerezleri kullanılabilir:
                </p>
                <ul className="space-y-2 font-body text-gray-700">
                  <li className="flex items-start space-x-2">
                    <i className="ri-google-line text-secondary mt-1 flex-shrink-0"></i>
                    <span><strong>Google Analytics:</strong> Site trafiğini ve kullanıcı davranışlarını analiz etmek için</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-facebook-line text-secondary mt-1 flex-shrink-0"></i>
                    <span><strong>Facebook Pixel:</strong> Reklam kampanyalarının etkinliğini ölçmek için</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-map-pin-line text-secondary mt-1 flex-shrink-0"></i>
                    <span><strong>Google Maps:</strong> Harita hizmetleri için</span>
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  6. Çerez Politikası Güncellemeleri
                </h2>
                <p className="font-body text-gray-700 leading-relaxed">
                  Bu çerez politikası zaman zaman güncellenebilir. Önemli değişiklikler olduğunda, web sitemizde bildirim yapılacaktır. Politikayı düzenli olarak kontrol etmenizi öneririz.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4 flex items-center">
                  <span className="w-2 h-8 bg-secondary rounded-full mr-3"></span>
                  7. İletişim
                </h2>
                <p className="font-body text-gray-700 leading-relaxed mb-4">
                  Çerez politikamız hakkında sorularınız varsa, bizimle iletişime geçebilirsiniz:
                </p>
                <div className="bg-gray-50 rounded-lg p-6">
                  <ul className="space-y-3 font-body text-gray-700">
                    <li className="flex items-start space-x-2">
                      <i className="ri-mail-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>E-posta:</strong> info@izmirvizedanismanlik.net</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-phone-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>Telefon:</strong> +90 542 267 11 71</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <i className="ri-map-pin-line text-secondary mt-1 flex-shrink-0"></i>
                      <span><strong>Adres:</strong> Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı, Konak/İzmir</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="bg-lightBlue/30 rounded-xl p-8 mt-8">
                <p className="font-body text-gray-700 leading-relaxed">
                  <strong className="text-darkBlue">Son Güncelleme:</strong> 1 Ocak 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
